import {Box, Card, CardContent, IconButton, Typography, useMediaQuery, useTheme} from "@mui/material";
import {RegistrationApiGet} from "./reg_api";
import React from "react";
import Timer from "./Timer";
import {useNavigate} from "react-router-dom";
import {Tables} from "../../apitypes";
import {useGetInterruptByIdQuery} from "../interruption/intr_api";
import dayjs from "dayjs";
import Delete from "@mui/icons-material/Delete";

type RegStatusProps = {
    reg: RegistrationApiGet,
    flex: boolean,
}

export function calculateTimeDifference(startTime: string, endTime: string | null): number {
    if (!endTime) return 0; // If EndTime is null, return null

    const startDate = new Date(startTime);
    const endDate = new Date(endTime);

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = endDate.getTime() - startDate.getTime();

    // Convert milliseconds to minutes
    return differenceInMilliseconds / 1000;

}

const InterruptLine = ({i, color}: { i: Tables<"interruptLine">, color: string }) => {
    const {data: interrupt} = useGetInterruptByIdQuery({id: i.InterruptID!})
    let intrSecs = 0;
    if (i.EndTime) {
        intrSecs = dayjs(i.EndTime).diff(dayjs(i.StartTime), "seconds", true)
    }
    return <>
        <Typography
            variant={"subtitle1"}>{interrupt ? interrupt.Code + " " + interrupt.Name : `${i.InterruptID}`}</Typography>
        <Typography variant={"body2"}>{new Date(i.StartTime).toLocaleString()}
            {i.EndTime && " - " + new Date(i.EndTime).toLocaleString() + ": " + (intrSecs / 60).toFixed(0) + ":" + (intrSecs % 60).toFixed(0) + " min"}

        </Typography>
        {!i.EndTime && <Typography variant={"h1"} sx={{color}}>
            <Timer showHours={false} origin={new Date(i.StartTime).getTime()}/>
        </Typography>}
    </>
}

const dateFormat: Intl.DateTimeFormatOptions = {
    minute: "2-digit",
    hour: "2-digit",
    second: "2-digit",
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",

};


export default ({reg, flex}: RegStatusProps) => {
    let statusColor = "success.main"
    let intr: Tables<"interruptLine"> | undefined = undefined
    if (reg.Status == "RegHalted") {
        statusColor = "error.main"
        intr = reg.interruptLine.find(intr => intr.EndTime === null)
    }
    const sumIntr = reg.interruptLine.filter(i => i.EndTime !== null).reduce((a, i) => a + dayjs(i.EndTime).diff(dayjs(i.StartTime), "seconds", true), 0)
    const theme = useTheme()
    const navigate = useNavigate()

    const md = useMediaQuery(theme.breakpoints.up('md'))

    const hideTimer = reg.Status === "RegHalted" && !md;

    const seconds = calculateTimeDifference(reg.StartTime, reg.EndTime);
    const hours = Math.trunc(seconds / 3600);
    const minutes = Math.trunc((seconds - hours * 3600) / 60);


    return <Box
        sx={{
            display: {xs: "flex", sm: flex ? "flex" : "block"},
            gap: "1em",
            flexWrap: "wrap",
            justifyContent: "space-around"
        }}>


        {!hideTimer && reg.Status != "RegFinished" && reg.Status != "RegHalted" && <Card sx={{flexGrow: 1, mb: "1em"}}>
            <CardContent>
                <Typography variant={"caption"}>Trajanje</Typography>
                <Typography variant={"h1"} sx={{color: statusColor}}>
                    <Timer showHours={true} origin={new Date(reg.StartTime).getTime()}/>
                </Typography>
            </CardContent>
        </Card>}

        {reg.Status == "RegHalted" && intr && <Card sx={{flexGrow: 1, mb: "1em"}}>
            <CardContent>
                <InterruptLine i={intr} color={statusColor}/>
            </CardContent>
        </Card>}

        <Card sx={{mb: "1em", flexGrow: 1, display: {xs: "none", md: "block"}}}>
            <CardContent>
                <Typography variant={"caption"}>Začetek:</Typography>
                <Typography variant={"h3"}>{new Date(reg.StartTime).toLocaleString("sl", dateFormat)}</Typography>
                {reg.EndTime && <Typography variant={"caption"}>Konec</Typography>}
                {reg.EndTime &&
                    <Typography variant={"h3"}>{new Date(reg.EndTime).toLocaleString("sl", dateFormat)}</Typography>}
                {reg.EndTime && <Typography variant={"caption"}>Delo:</Typography>}
                {reg.EndTime && <Typography variant={"h5"}>
                    {hours}:{minutes < 10 && 0}{minutes} [h:mm]
                </Typography>}
                {sumIntr > 0 && <>
                    <Typography variant={"caption"}>Prekinitve:</Typography>
                    <Typography variant={"h5"}> {(sumIntr / 60).toFixed(0)}:{(sumIntr % 60).toFixed(0)} min</Typography>
                </>}
            </CardContent>
        </Card>

        {!intr && reg.interruptLine.length > 0 &&
            <Card sx={{mb: "1em", flexGrow: 1, display: {xs: "none", md: "block"}}}>
                <CardContent>
                    {reg.interruptLine.map((i) => <InterruptLine key={i.id} i={i} color={statusColor}/>)}
                </CardContent>
            </Card>}
    </Box>;
}
